export const logConfig = {
  logLevel: process.env.REACT_APP_LOG_LEVEL,
};
